/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class SchedulerAPI extends ApiClient {
  constructor() {
    super('wasapi/scheduler', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  action(id, action) {
    return axios.post(`${this.url}/${id}/${action}`);
  }

  cancel(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  uploadAttachment(file) {
    const formData = new FormData();
    formData.append('attachment', file);
    return axios.post(`${this.baseUrl()}/upload`, formData);
  }
}

export default new SchedulerAPI();
